import * as KundeRestCache  from './rest/kunde-rest-cache';
import { Kunde } from './rest/kunde-rest';
import * as AvgiverMellomLagring from './rest/avgiver-mellomlagring-rest'
import * as AvgiverCache from './avgiver-cache';

const navn = (kunde: Kunde) => kunde.navn ? `${kunde.navn.fornavn} ${kunde.navn.etternavn}` : `${kunde.fnr.substring(0, 6)}`;
const setId = (id: string, kundeId: string, type: Avgivertype) => type === 'meg' ? kundeId : id;

export {
    ValgtAvgiver,
    lag,
    lagre,
    hent,
    lagreMegSomDefault
}

export type Avgivertype = 'enhet' | 'meg'

interface ValgtAvgiver {
    id: string;
    type: Avgivertype;
    navn: string;
    when: number;
    antallAvgivere: number | 'ukjent';
    automatiskSatt: boolean;
}

function lag(id, type, fnr: string, navn: string, opts) : ValgtAvgiver{
    const kundeId = fnr.substring(7, 11);
    opts = opts || {};

    return {
        id: setId(id, kundeId, type),
        type: type,
        navn: navn,
        when: new Date().getTime(),
        antallAvgivere: opts.antallAvgivere || 'ukjent',
        automatiskSatt: opts.automatiskSatt || false
    };
}

async function lagre(avgiver : ValgtAvgiver) : Promise<ValgtAvgiver>{
    let nyavgiver = await AvgiverMellomLagring.lagre(avgiver);
    AvgiverCache.lagre(Promise.resolve(nyavgiver));
    return nyavgiver;
}

async function hent() : Promise<ValgtAvgiver> {
    const avgiverCachetPromise = AvgiverCache.hent();
    if(avgiverCachetPromise){
        return avgiverCachetPromise;
    }
    else{
        const hentFraMellomlagringPromise =  hentFraMellomlagring();
        AvgiverCache.lagre(hentFraMellomlagringPromise);
        return hentFraMellomlagringPromise;
    }
}

async function hentFraMellomlagring() : Promise<ValgtAvgiver> {
    try{
        const avgiver = await AvgiverMellomLagring.hent();
        AvgiverCache.lagre(Promise.resolve(avgiver));
        return avgiver;
    } catch(err){
        console.error("Feil under henting fra mellomlagring, lagrer meg som default", err);
        const lagreMegSomDefaultPromise = hentKundeOgLagreMegSomDefault();
        AvgiverCache.lagre(lagreMegSomDefaultPromise);
        return lagreMegSomDefaultPromise;         
    }
}

async function hentKundeOgLagreMegSomDefault() : Promise<ValgtAvgiver>{
    try{
       const meg = await KundeRestCache.hentMeg();
       return lagreMegSomDefault(meg);
    } catch(err){
        console.error("Feil med Kunde");
        throw(err);
    }
}

function lagreMegSomDefault(kunde: Kunde, antallAvgivere: number | 'ukjent' = 'ukjent', automatiskSatt: boolean = true): ValgtAvgiver {

    const fnr = kunde.fnr;
    const avgiver = lag(fnr, 'meg',fnr,navn(kunde), { automatiskSatt: automatiskSatt, antallAvgivere: antallAvgivere });

    lagre(avgiver);

    return avgiver;
}
